import { FunctionComponent, ReactNode } from "react";
import Column from "./Column";
import Text from "./Text";
import Button from "./Button";
import SvgFragment from "../fragments/SvgFragment";

interface IEmptyPageProps {
  title?: string;
  label?: string;
  svgType?: string;
  labelNode?: ReactNode;
  buttonTitle?: string;
  onClick?: () => void;
}

const EmptyPage: FunctionComponent<IEmptyPageProps> = ({
  title,
  label,
  labelNode,
  svgType,
  buttonTitle,
  onClick,
}) => {
  return (
    <Column alignItems gap="16px">
      <SvgFragment type={svgType} />
      <Text $heading3>{title}</Text>
      <Text $lighter $paragraph1>
        {label}
      </Text>
      {labelNode}
      {buttonTitle && (
        <Button $type="blue" $width="138px" onClickHandler={onClick}>
          {buttonTitle}
        </Button>
      )}
      {/* <div style={{padding: '0 10px', marginTop: '15px'}}><Button $type="blue">Go to Chrome Web Store</Button></div> */}
    </Column>
  );
};

export default EmptyPage;
